//
//
//
//
//
//
//
//
//
//
//

import upArrowIcon from '~/static/list-item-up.svg';
import downArrowIcon from '~/static/list-item-down.svg';

export default {
  props: {
    name: {
      type: String,
      required: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: !this.open && this.name,
      downArrowIcon,
      upArrowIcon,
    };
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
